/**
 * @file Contains possible loan actions
 */

import { web } from "@kikoff/proto/src/protos";
import { webRPC } from "@kikoff/proto/src/rpc";
import { serverNow } from "@kikoff/utils/src/number";
import {
  handleFailedStatus,
  handleProtoStatus,
  protoTime,
} from "@kikoff/utils/src/proto";

import { Experiment } from "@feature/experiment";
import { track } from "@util/analytics";
import { nativeDispatch } from "@util/mobile";

import { fetchUser } from "./user";

export const withdrawVoucherFunds = (
  request: web.public_.IWithdrawVoucherFundsRequest
) => (dispatch) => {
  return webRPC.Cbs.withdrawVoucherFunds(request).then(
    handleProtoStatus({
      async SUCCESS() {
        track("CBL - Withdraw Voucher Funds - Withdraw Funds Success");
        nativeDispatch("invalidate");
        await dispatch(fetchUser.loans());
      },
      _DEFAULT: handleFailedStatus("Failed to pay loan installment"),
    })
  );
};

export const cblCreditCardCutoffDate = new Date("2024-08-26");

export type WithdrawTransferType = Exclude<
  keyof typeof web.public_.WithdrawVoucherFundsRequest.FundableResourceType,
  "PAPER_CHECK"
>;

export const useOverdueInstallments = (loan: web.public_.ILoan) => {
  return loan.loanInstallments.filter(
    ({ paid, billingEnd }) => !paid && protoTime(billingEnd) < serverNow()
  );
};

export function variantToName(
  variant: Experiment.VariantByName["cblOnboardingV2Experiment"]
): "Hybrid Credit Builder" | "Smart Savings Builder" | "Credit Builder Loan" {
  if (variant === "hybrid_credit_builder") {
    return "Hybrid Credit Builder";
  }
  if (variant === "smart_savings_builder") {
    return "Smart Savings Builder";
  }
  return "Credit Builder Loan";
}
